// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"v7-z"};